import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { BookingItemNamePipe } from '../pipes/booking-item-name.pipe';
import { MatDialog } from '@angular/material/dialog';
import { BookingConflictsDialogComponent } from '../dialogs/booking-conflicts-dialog/booking-conflicts-dialog.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgClass } from '@angular/common';

@Component({
  selector: 'booking-item-name-cell',
  template: `
    <div class="flex flex-row justify-start items-center h-full gap-x-2">
      <span class="flex flex-col justify-center items-center">
        <mat-icon
          *ngIf="params.data.conflict_level"
          [ngClass]="{
            'text-red-500': params.data.conflict_level === 2,
            'text-yellow-500': params.data.conflict_level === 1
          }"
          class="cursor-pointer"
          [matTooltip]="
            params.data.conflict_level === 2
              ? 'Insufficient Stock'
              : 'Conflicts exist'
          "
          (click)="openConflicts(params.data.id)"
          >warning
        </mat-icon>
      </span>
      <p>{{ params.data | bookingItemName }}</p>
    </div>
  `,
  providers: [BookingItemNamePipe],
  standalone: true,
  imports: [NgIf, MatIcon, NgClass, MatTooltip, BookingItemNamePipe]
})
export class BookingItemNameCellComponent implements AgRendererComponent {
  params: any;

  constructor(private dialog: MatDialog) {}

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}

  openConflicts(itemId: number) {
    this.dialog.open(BookingConflictsDialogComponent, {
      data: {
        type: 'bookingItem',
        id: itemId,
        bookingId: this.params.data.booking_id,
        bookingItemId: itemId
      }
    });
  }
}
